$ ->
  fadeOutClass = "tdd-fx tdd-fx--fast tdd-fx--fade-out"

  $('body').on 'click.tddNotification', '[data-tdd-dismiss]', ->
    id = $(this).data("tdd-dismiss")
    key = $(this).data("tdd-key") || "notificationBanner"
    $(id)
      .one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', ->
        $(id).css "display", "none"
        return
      )
      .addClass fadeOutClass

    Cookies.set key, "dismissed"
  return